export function currentEnvironment() {
  return document.querySelector("meta[name='environment']")?.content;
}
